import { Container } from '@components/gassan-ui'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import React, { FC } from 'react'

type WorldOfRolexArticleIntroProps = {
  title: string
  description: string
  date: string
  className?: string
}

export const WorldOfRolexArticleIntro: FC<WorldOfRolexArticleIntroProps> = ({
  title,
  description,
  date,
  className,
}) => {
  return (
    <Container
      className={cn(
        `mb-[60px] grid w-full grid-cols-6 gap-2 md:grid-cols-12 lg:mb-[90px]`,
        className,
      )}
    >
      <div className="col-span-6 flex flex-col items-start md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
        <Heading variant="headline50" className="mb-4 text-rolexBrown lg:mb-6">
          {title}
        </Heading>
        <Heading variant="headline26" className="mb-4 whitespace-pre-line lg:mb-6">
          {description}
        </Heading>
        <Text variant="body20">{date}</Text>
      </div>
    </Container>
  )
}
